// eslint-disable-next-line import/prefer-default-export
export const ANALYTICS_ES = {
  // Toltips
  ResetDate: 'Quitar fecha',

  DataStudio: 'Data studio',
  GeneralAnalytics: 'Analíticas generales',
  DataNPS: 'Analíticas de NPS',

  // Data Studio
  Active: 'Activa',
  Deleted: 'Eliminada',
  Paused: 'Pausada',
  Closed: 'Cerradas',
  NamelessVacancy: 'Vacante sin nombre',
  TrafficPerDevice: 'Tráfico por dispositivos',
  TrafficPerRegion: 'Tráfico por estado',
  TrafficPerInstitutes: 'Tráfico por Institutos',
  Mobile: 'Móvil',
  Tablet: 'Tableta',
  Desktop: 'Ordenador',
  WhereVisitorsComeFrom: '¿De dónde vienen tus visitantes?',
  Export: 'Exportar',
  DetailedView: 'Vista detallada',
  Name: 'Nombre',
  Status: 'Estado',
  Date: 'Fecha',
  ViewsLP: 'Vistas (LP)',
  ViewsI: 'Vistas (Institutos)',
  ViewsM: 'Vistas (Móvil)',
  ViewsT: 'Vistas (Tableta)',
  ViewsD: 'Vistas (Ordenador)',

  // General Analytics
  VacanciesWithWarning: 'Vacantes - (No sujetas a las fechas establecidas)',
  WrongDatesWarning: 'La fecha inicial debe ser menor a la final.',
  Period: 'Período',
  Devices: 'Dispositivos',
  Total: 'Total',
  ActivePlural: 'Activas',
  PausedPlural: 'Pausadas',
  ClosedPlural: 'Cerradas',
  ClosedSingle: 'Cerrada',
  Audience: 'Audiencia',
  TotalVisits: 'Visitas totales',
  Source: 'Fuente',
  Institutes: 'Institutos',
  ComingSoon: '¡Próximamente!',
  Applicants: 'Candidatos',
  Pending: 'Pendientes',
  InProcess: 'En proceso',
  Accepted: 'Aceptados',
  Rejected: 'Rechazados',

  // Single Analytics
  Vacancies: 'Vacantes',
  Vacancy: 'Vacante:',
  Published: 'Publicado:',
  Platform: 'Plataforma:',
  SettleTime: 'Tiempo de colocación:',
  Visits: 'Visitas:',
  days: 'días',
  SingularPending: 'Pendiente',
  OrganicApplications: 'Postulaciones orgánicas',
  ManualApplications: 'Postulaciones manuales',
  TotalApplications: 'Total de postulaciones',
  TotalCandidates: 'Total de candidatos',
  Applications: 'Postulaciones',
  ConversionRate: 'Tasa de Conversión',
  AverageTimeByState: 'Tiempo promedio por estado (General)',
  GeneralInformationByVacancy: 'Información general por vacante',
  morePostulations: 'Vacantes más postuladas',

  vacanciesDisplay: 'Visualización de vacantes',
  clickApply: 'Clic para postularse',
  candidateTotal: 'Total de candidatos',
  TotalVacancy: 'Total de vacantes',
  pending: 'Pendientes',
  inprocess: 'En proceso',
  accepted: 'Aceptados',
  rejected: 'Rechazados',
  generalVacancy: 'Tiempo promedio por fase',

  // Tabla
  vancateTable: 'Vacante',
  DatePublish: 'Fecha de publicación',
  PlacementDate: 'Fecha de colocación',
  CandidateAccepted: 'Candidato aceptado',
  statusVacancy: 'Estado de la vacante',
  activeTime: 'Tiempo activo',

  mobile: 'Móvil',
  tableta: 'Tableta',
  desktop: 'Ordenador',
  views: 'Vistas',
  state: 'Estado',
  percentage: 'Porcentaje',
  respondents: 'Respondientes',
  answerRate: 'Tasa de respuesta',
  sended: 'Enviados',
  vacanciesWithNPS: 'Vacantes que envian NPS',
  generalInfo: 'Información general',
  abandonmentRate: 'Abandonos',
  send: 'Enviados',
  answered: 'Respondidos',
  analiticsNPS: 'Analíticas NPS',
  results: 'Resultados',
  noAnswers: 'No hay información',
  waiting: 'Espere un momento por favor',
  createReport: 'Creando reporte',
  download: 'Descargar',
  updateEvery24: 'Esta gráfica es actualizada cada 24 horas.',

  postulationsClic: 'Clics en postular',
  postulations: 'Postulaciones',
  postingVacancies: 'Publicación de vacantes',

  columnName: 'Nombre de la columna',
  informationPerColumn: 'Información general por columna',
  sitesViewed: 'Sitios de visualización',
  ignoreFilters: 'Este gráfico ignora los filtros de fecha',
};
